import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Actions from "components/BannerSet/Actions";
import BannerSetForm from "components/BannerSet/BannerSetForm";
import DataGrid from "components/BannerSet/DataGrid";
import PropTypes from "prop-types";
import { memo } from "react";

const BannerSet = ({ create, update }) => {
  if (create || update) {
    return <BannerSetForm />;
  }

  return (
    <Box sx={{ flexGrow: 1, py: 3, px: 1 }}>
      <Typography
        variant="h4"
        fontWeight="600"
        mb={1}
        sx={{ fontSize: { md: "1.5rem", lg: "2rem" } }}
      >
        BANNER SET
      </Typography>
      <Actions />
      <DataGrid />
    </Box>
  );
};

export default memo(BannerSet);

BannerSet.propTypes = {
  create: PropTypes.bool,
  update: PropTypes.bool,
};

BannerSet.defaultProps = {
  create: false,
  update: false,
};
